define('GameDayCore/GDModel/ValueObjects/Plays/Pitch',['require','exports','module','../ValueObjectFactory','../../enums/baseball/PitchTypes','../../enums/baseball/PitchColors','../../../GDUtil/dataMapping/LocalizationUtil'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        PitchTypes = require("../../enums/baseball/PitchTypes"),
        PitchColors = require("../../enums/baseball/PitchColors"),
        LocalizationUtil = require("../../../GDUtil/dataMapping/LocalizationUtil"),
        reCamel = /\_(\w)/ig,
        pAlpha = "1.0",
        rgba_open = "rgba(",
        rgba_close = ")",
        rgba_sep = ", ",
        colorCache={};

	VO.create(Pitch,{
        getPitchType : function(key) {
        	key=key||this.pitchType;
            return pitchTypes[key]
        },

        getPitchTypes : function () {
            return PitchTypes;
        },

        getPitchColor : function(key) {
        	key=key||this.pitchType;
            return buildRGBA(PitchColors.pitchColors[key || 'UN']);
        },

        getPitchBallColor : function(key) {
        	key=key||this.type;
            return buildRGBA(PitchColors.pitchBallColors[key]);
        }

	});

	function Pitch($data) {
		var vo = VO.ensureVO(this, Pitch),
			data = $data;

		vo.name = parseName(data) || "pitch";
		vo.colorCommentary = data.cc || "";
		vo.id = data.id || "";
		vo.des = parseDescription(data);
		vo.type = data.type || "";
		vo.pitchType = data.pitch_type || "";
        vo.pitchDisplayName = parseDisplayName(data);
		vo.isPitch = (data.name === "pitch" || data._nodeName === "p");
		vo.isInPlay = data.is_in_play;
		vo.count = {
			balls: data.balls,
			strikes: data.strikes
		};
		vo.x = safeParseFloat(data.x) || 0;
		vo.y = safeParseFloat(data.y) || 0;
		vo.startSpeed = safeParseFloat(data.start_speed).toFixed(0)*1 || 0;
		vo.endSpeed = safeParseFloat(data.end_speed).toFixed(0)*1 || 0;
		vo.szTop = safeParseFloat(data.sz_top) || 0;
		vo.szBot = safeParseFloat(data.sz_bot) || 0;
		vo.pfxX = safeParseFloat(data.pfx_x) || 0;
		vo.pfxZ = safeParseFloat(data.pfx_z) || 0;
		vo.px = safeParseFloat(data.px) || 0;
		vo.pz = safeParseFloat(data.pz) || 0;
		vo.x0 = safeParseFloat(data.x0) || 0;
		vo.y0 = safeParseFloat(data.y0) || 0;
		vo.z0 = safeParseFloat(data.z0) || 0;
		vo.vx0 = safeParseFloat(data.vx0) || 0;
		vo.vy0 = safeParseFloat(data.vy0) || 0;
		vo.vz0 = safeParseFloat(data.vz0) || 0;
		vo.ax = safeParseFloat(data.ax) || 0;
		vo.ay = safeParseFloat(data.ay) || 0;
		vo.az = safeParseFloat(data.az) || 0;
		vo.breakX = safeParseFloat(data.break_x) || 0;
		vo.breakY = safeParseFloat(data.break_y) || 0;
		vo.breakZ = safeParseFloat(data.break_z) || 0;
		vo.breakAngle = safeParseFloat(data.break_angle) || 0;
		vo.breakLength = safeParseFloat(data.break_length) || 0;
		vo.nasty = safeParseFloat(data.nasty) || 0;
		vo.sv_id = data.sv_id || "";
		vo.idx = parseInt(data.idx,10) || 0;
		vo.tfs_zulu = data.tfs_zulu || "";
		vo.tfs = data.tfs || "";
        vo.resultingBalls = 0;
        vo.resultingStrikes = 0;
        vo.isPickOff = (vo.type == "");
        vo.is3DPitch = (!!(vo.y0 && vo.x0 && vo.z0));
    }

	function buildRGBA(colorString) {
        return colorCache[colorString]=colorCache[colorString]||(rgba_open + colorString + rgba_sep + pAlpha + rgba_close);
    }        

	function safeParseFloat(num){
		return num && parseFloat(num)||0;
	}
	
	function parseName(data) {
		if (data.name == "p") {
			return "pitch";
		} else {
			return data.name;
		}
	}

    function parseDescription(data) {
		var val = (typeof data.des === "string") ? data.des : "";
		if (LocalizationUtil.isEnglish()) return val;

		var localizedDes = data[("des_" + LocalizationUtil.language())];
		val = (typeof localizedDes === "string") ? localizedDes : val;

		return val;
	}

    function parseDisplayName(data) {
        var pName = "";
        if (LocalizationUtil.isEnglish()) {
            pName = PitchTypes[data.pitch_type] || "";
        } else {
            pName = PitchTypes[data.pitch_type + "_ES"] || "";
        }

        return pName;
    }

	return Pitch;
});
